///<reference path="../../definitions/weather.d.ts"/>
///<reference path="../util/SDTDate.ts"/>
///<reference path="../Const.ts"/>

namespace app.model{
	import SDTDate = app.util.SDTDate;
	export class TideName{
		data:TideNameData[] = [];

		parseData(data:TideNameJSON, location:string) {
			data.tidal.forEach((elm) => {
				this.data.push({
					date: new SDTDate(elm.date, Const.DATE_CHOSEKI),
					name: elm.tidal
				})
			});
		}
	}
}